export interface ServersEntity {
  active:       boolean;
  ownerId:      number;
  port:         number;
  serverDomain: string;
  serverId:     number;        // 保持为数字（原始 server_id）
  serverIp:     string;
  serverName:   string;
  ssl:          boolean;
  uuid:         string | null; // UUID 字段，用于API调用
}

export class Convert {
  public static toServersEntity(json: any): ServersEntity[] {
    if (Array.isArray(json)) {
      return json.map(item => ({
        active: Boolean(item.is_active),
        ownerId: Number(item.owner_id),
        port: Number(item.port) || 0,
        serverDomain: item.server_domain || '',
        serverId: Number(item.server_id),  // 保持为数字
        serverIp: item.server_ip === 'null' ? '' : (item.server_ip || ''),
        serverName: item.server_name || '',
        ssl: Boolean(item.ssl),
        uuid: item.uuid || null           // 保留 UUID 字段用于API调用
      }));
    }
    return [];
  }

  public static serversEntityToJson(value: ServersEntity[]): string {
    return JSON.stringify(value, null, 2);
  }
}
